import React from 'react';
import { Plus, Trash2, GripVertical } from 'lucide-react';

const S = {
  label: {
    fontSize: '0.7rem', fontWeight: 700, color: '#c5a059', textTransform: 'uppercase',
    letterSpacing: '0.06em', marginBottom: '4px', display: 'block',
  },
  input: {
    width: '100%', background: 'rgba(7, 21, 38, 0.8)', border: '1px solid rgba(197,160,89,0.25)',
    borderRadius: '8px', padding: '8px 12px', fontSize: '0.8rem', color: '#e2e8f0',
    outline: 'none', boxSizing: 'border-box', fontFamily: "'Inter', sans-serif",
  },
  btnSecondary: {
    background: 'rgba(197,160,89,0.1)', color: '#c5a059', border: '1px solid rgba(197,160,89,0.3)',
    borderRadius: '10px', padding: '8px 14px', fontSize: '0.75rem', fontWeight: 700,
    cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '7px',
  },
  btnDanger: {
    background: 'rgba(239,68,68,0.1)', color: '#f87171', border: '1px solid rgba(239,68,68,0.3)',
    borderRadius: '8px', padding: '6px 10px', fontSize: '0.72rem', fontWeight: 700,
    cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px',
  },
};

export const QuestionEditor = ({ questions = [], onChange }) => {
  const updateQuestion = (index, patch) => {
    onChange(questions.map((q, i) => (i === index ? { ...q, ...patch } : q)));
  };

  const updateOption = (qIndex, optIndex, value) => {
    const q = questions[qIndex];
    const options = q.options.map((o, i) => (i === optIndex ? value : o));
    updateQuestion(qIndex, { options });
  };

  const addQuestion = () => {
    onChange([
      ...questions,
      {
        id: `q_${Date.now()}`,
        question: '',
        options: ['', '', '', ''],
        correct_index: 0,
        explanation: '',
      },
    ]);
  };

  const removeQuestion = (index) => {
    onChange(questions.filter((_, i) => i !== index));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {questions.map((q, qIdx) => (
        <div key={q.id || qIdx} style={{
          padding: '14px', borderRadius: '10px', background: 'rgba(7,21,38,0.5)',
          border: '1px solid rgba(197,160,89,0.2)', display: 'flex', flexDirection: 'column', gap: '10px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <GripVertical size={14} style={{ color: '#64748b', flexShrink: 0 }} />
            <span style={{ fontSize: '0.72rem', fontWeight: 800, color: '#c5a059', fontFamily: 'monospace', flexShrink: 0 }}>
              Pregunta {qIdx + 1}
            </span>
            <button type="button" onClick={() => removeQuestion(qIdx)} style={{ ...S.btnDanger, marginLeft: 'auto', padding: '4px 8px' }}>
              <Trash2 size={12} />
            </button>
          </div>

          <div>
            <label style={S.label} htmlFor={`q-${q.id || qIdx}-question`}>Enunciado</label>
            <textarea
              id={`q-${q.id || qIdx}-question`}
              rows={2}
              value={q.question}
              onChange={(e) => updateQuestion(qIdx, { question: e.target.value })}
              style={{ ...S.input, resize: 'vertical', fontFamily: "'Inter', sans-serif" }}
              placeholder="Escribe la pregunta..."
            />
          </div>

          <div>
            <label style={S.label}>Opciones de Respuesta (marca la correcta)</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {q.options.map((opt, optIdx) => {
                const isCorrect = q.correct_index === optIdx;
                const optId = `q-${q.id || qIdx}-opt-text-${optIdx}`;
                return (
                  <div key={optIdx} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="radio"
                      name={`correct_${q.id || qIdx}`}
                      id={`q-${q.id || qIdx}-opt-radio-${optIdx}`}
                      checked={isCorrect}
                      onChange={() => updateQuestion(qIdx, { correct_index: optIdx })}
                      aria-label={`Marcar la opción ${String.fromCharCode(65 + optIdx)} de la pregunta ${qIdx + 1} como correcta`}
                      style={{ accentColor: '#34d399', cursor: 'pointer', flexShrink: 0 }}
                    />
                    <input
                      type="text"
                      id={optId}
                      aria-label={`Opción ${String.fromCharCode(65 + optIdx)} de la pregunta ${qIdx + 1}`}
                      value={opt}
                      onChange={(e) => updateOption(qIdx, optIdx, e.target.value)}
                      style={{
                        ...S.input,
                        borderColor: isCorrect ? 'rgba(52,211,153,0.5)' : 'rgba(197,160,89,0.2)',
                        color: isCorrect ? '#34d399' : '#e2e8f0',
                      }}
                      placeholder={`Opción ${String.fromCharCode(65 + optIdx)}`}
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <div>
            <label style={S.label} htmlFor={`q-${q.id || qIdx}-explanation`}>Explicación (opcional)</label>
            <textarea
              id={`q-${q.id || qIdx}-explanation`}
              rows={2}
              value={q.explanation || ''}
              onChange={(e) => updateQuestion(qIdx, { explanation: e.target.value })}
              style={{ ...S.input, resize: 'vertical', fontFamily: "'Inter', sans-serif" }}
              placeholder="Explicación que verá el alumno tras responder..."
            />
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={addQuestion}
         style={{ 
          ...S.btnSecondary,  justifyContent: 'center' }} className="adm-btn adm-btn--secondary"
      >
        <Plus size={14} />
        <span>Agregar Pregunta</span>
      </button>
    </div>
  );
};
